module.exports = "<p>\n  404\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /Users/magnustrandokken/Desktop/Magson/Web/Foko/foko-angular/src/app/ui/not-found/not-found.component.html
// module id = ../../../../../src/app/ui/not-found/not-found.component.html
// module chunks = main